<template>
    <div class="e-select">
        <select v-model="selected" :id="filterId" :name="filterId">
            <option v-for="(option, optionKey) in options" :value="optionKey">{{ $t(option) }}</option>
        </select>
    </div>
</template>

<script>
    import {EventBus} from '../../services/eventBus'

    export default {
        name: "Dropdown",
        props: {
            options: Object,
            value: String,
            group: String,
            filtergroup: String,
            filterId: String
        },
      data () {
        return {
            selected: ''
        }
      },
      watch: {
        selected() {
          let filter = {filtergroup: this.filtergroup, group:this.group, value: this.value, selects: this.selected, filterId: this.filterId}
          EventBus.$emit('setFilter', filter)
        }
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/Dropdown.vue